import React from 'react';
import LocalizedLink from 'components/LocalizedLink';
import { Translator } from 'Translator';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import useAuthStore from '~/authentication/store';

const CSS = require('./NavbarList.less');

interface ListItemOuterProps {
  onClick: () => void;
}

function LoginListItem({ onClick }: ListItemOuterProps) {
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn());
  if (isLoggedIn) {
    return null;
  }
  return (
    <li className={CSS.MenuItem} onClick={onClick}>
      <LocalizedLink className={CSS.MenuItemButton} to={{ pathname: '/login/', state: { modal: true } }}>
        {Translator.translate('Forms.Buttons.Login', {}, true, 'Log in')}
      </LocalizedLink>
      <div className={CSS.IconContainer}/>
    </li>
  );
}

function SignUpListItem({ onClick }: ListItemOuterProps) {
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn());
  if (isLoggedIn) {
    return null;
  }
  return (
    <li className={CSS.MenuItem} onClick={onClick}>
      <LocalizedLink className={CSS.MenuItemButton} to={{ pathname: generatePathnameWithLangCode('/signup/', Translator.getLanguageCode()), state: { modal: true } }}>
        {Translator.translate('Forms.Buttons.Signup', {}, true, 'Sign up')}
      </LocalizedLink>
      <div className={CSS.IconContainer}/>
    </li>
  );
}

export {
  LoginListItem,
  SignUpListItem
};
